import { useState } from "react";

export const BeforeAfter = ({ before, after, altBefore = "Before renovation", altAfter = "After renovation" }) => {
  const [pos, setPos] = useState(50);
  return (
    <div className="relative aspect-[16/10] overflow-hidden rounded-2xl" data-testid="before-after-slider">
      <img src={after} alt={altAfter} className="absolute inset-0 h-full w-full object-cover" loading="lazy" />
      <img
        src={before}
        alt={altBefore}
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
      />
      <div className="absolute inset-y-0 w-0.5 bg-gold" style={{ left: `${pos}%` }} aria-hidden="true">
        <span className="absolute top-1/2 -ml-4 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full bg-gold text-[10px] font-bold text-charcoal">
          ⇔
        </span>
      </div>
      <span className="absolute left-3 top-3 rounded-full bg-ink/70 px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-white">Before</span>
      <span className="absolute right-3 top-3 rounded-full bg-gold px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-charcoal">After</span>
      <input
        type="range"
        min="0"
        max="100"
        value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        aria-label="Compare before and after"
        data-testid="before-after-range"
        className="absolute inset-0 h-full w-full cursor-ew-resize opacity-0"
      />
    </div>
  );
};
